import React from "react";

import { minimalClientI18n } from "@kazoohr/internationalization";

import { locales } from "../../../locales";

export function InternationalizationWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isI18nReady, setIsI18nReady] = React.useState(false);

  React.useEffect(() => {
    const initializeI18n = async () => {
      try {
        await minimalClientI18n({ locales });
        setIsI18nReady(true);
      } catch (error) {
        console.error("Unable to initialize i18n", error); // eslint-disable-line no-console
        setIsI18nReady(true);
      }
    };

    initializeI18n();
  }, []);

  if (!isI18nReady) {
    return null;
  }

  return <>{children}</>;
}
